


















































































































































































































































































































import { Component, Prop, Inject } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs/unified-ui-framework/src/shared/sw-extended-vue';
import { SwIcon } from '@libs/unified-ui-framework/src/shared/sw-icon';
import { SwStatusFlag } from '@libs/unified-ui-framework/src/shared/sw-status-flag';
import { SwToggle } from '@libs/unified-ui-framework/src/shared/sw-toggle';
import { SwTransitionExpand } from '@libs/unified-ui-framework/src/shared/sw-transition';
import SwPanelGroup from '@libs/unified-ui-framework/src/shared/sw-panel-group.vue';
import Ns from '../../../../assets/ns.svg';
import CASB from '../../../../assets/Icon_CASB_Color.svg';
import IconEndpoint from '../../../../assets/Icon_Endpoint_SSC_Color.svg';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';
import {
  ProvidedPanelParam,
  PanelSummaryConfig,
  PanelBulletConfig,
  ProductNames,
} from './types';

/**
 * @event request-toggle-change `(toggled: boolean)`
 */
@Component({
  components:{
    SwIcon,
    SwToggle,
    SwStatusFlag,
    SwTransitionExpand,
  },
})
export default class SwPanel extends SwExtendedVue{
  // props
  @Prop({ type: String, required: true })
  panelId: string;

  @Prop({ type: String, default: '' })
  title: string;

  @Prop({ type: Object, default: null })
   options: ProductNames | null;
  @Prop({ type: String, default: '' })
  img: string;

  @Prop({ type: String, default: '' })
  percentage: string;

  @Prop({ type: Object, default: null })
  summaryConfig: PanelSummaryConfig | null;
  @State((state: RootStoreState) => (state.CoreStoreModule.layerOneInnerLayersActivatedWhatIf))
  layerOneInnerLayersActivatedWhatIf: any;

  @State((state: RootStoreState) => (state.CoreStoreModule.layerTwoInnerLayersActivatedWhatIf))
  layerTwoInnerLayersActivatedWhatIf: any;

  @State((state: RootStoreState) => (state.CoreStoreModule.layerThreeInnerLayersActivatedWhatIf))
  layerThreeInnerLayersActivatedWhatIf: any;

  @Prop({ type: Array, default: null })
  panelBullets: PanelBulletConfig[] | null;
  @Inject()
  panelParam: ProvidedPanelParam;
  // data
  cssPrefix: string = 'sw-panel-simulator';
  currActiveLayer:any = [false, false];

  nsImg: any = Ns;
  mounted() {
    this.nsImg = this.computeImg();
    if (this.title === 'ENDPOINT SECURITY') {
      this.currActiveLayer = this.layerOneInnerLayersActivatedWhatIf;
    } else if (this.title === 'CAS AND EMAIL') {
      this.currActiveLayer = this.layerTwoInnerLayersActivatedWhatIf;
    } else if (this.title === 'NETWORK SECURITY') {
      this.currActiveLayer = this.layerThreeInnerLayersActivatedWhatIf;
    }
  }
  computeImg() {
    if (this.img === 'Ns') {
      this.nsImg = Ns;
    } else if (this.img === 'CASB') {
      this.nsImg = CASB;
    } else if (this.img === 'IconEndpoint') {
      this.nsImg = IconEndpoint;
    }
    return this.nsImg;
  }
  // computed
  get isExpanded(): boolean {
    return this.panelParam.expandedPanels.findIndex(e => (e === this.panelId)) >= 0;
  }

  get theme(): string {
    return this.panelParam.theme;
  }

  get toggleName(): string {
    return `__panel-toggle-${Math.floor(Math.random() * 100000000)}`;
  }

  start() {
    if (this.title === 'ENDPOINT SECURITY') {
      this.currActiveLayer = this.layerOneInnerLayersActivatedWhatIf;
    } else if (this.title === 'CAS AND EMAIL') {
      this.currActiveLayer = this.layerTwoInnerLayersActivatedWhatIf;
    } else if (this.title === 'NETWORK SECURITY') {
      this.currActiveLayer = this.layerThreeInnerLayersActivatedWhatIf;
    }
  }

  // methods
  @Inject()
  claimPanelExpanded: SwPanelGroup['claimPanelExpanded'];

  onHeaderClick() {
    this.claimPanelExpanded(this.panelId, !this.isExpanded);
  }

  handleToggleChange(value: boolean, ev:Event) {
    ev.stopPropagation();
    this.$emit('request-toggle-change', value);
  }
}
